module.exports = __webpack_public_path__ + "img/tomatsauce_new_in_dutch_oven.ad311c6b.jpg";